import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDriverEvents extends Layout {
    labelApproved30: Label;
    labelApproved30Count: Label;
    labelApproved7: Label;
    labelApproved7Count: Label;
    labelTotal: Label;
    labelTotalEvents: Label;
    labelUnapproved30: Label;
    labelUnapproved30Count: Label;
    labelUnapproved7: Label;
    labelUnapproved7Count: Label;
    panelTotal: Panel;
    sourceDriverEvents: DataSource;
}
